import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { logger } from "@/utils/logger";

/**
 * Handles the OAuth login redirect flow. Parses the redirect query parameter
 * to preserve the user's intended destination, then sends them to the
 * appropriate Okta login endpoint.
 *
 * @param provider - The auth provider path segment (e.g. "console" or "corp")
 */
export function useLoginRedirect(provider: string) {
  onMounted(() => {
    const route = useRoute();

    logger.debug("Login redirect initiated", "provider:", provider);

    const queryRedirect = route.query.redirect;

    const redirectPath =
      typeof queryRedirect === "string"
        ? queryRedirect
        : Array.isArray(queryRedirect)
        ? queryRedirect[0]
        : null;

    if (!redirectPath || redirectPath === `/${provider}/login`) {
      window.location.href = `/auth/${provider}/login`;
      return;
    }

    const cleanPath = redirectPath.replace(/^\//, "");
    logger.debug("Redirecting to backend login with path:", cleanPath);
    window.location.href = `/auth/${provider}/login?path=${encodeURIComponent(cleanPath)}`;
  });
}
